var EsqueciSenhaForm = function () {

    this.init = function () {

        $('[data-component="esqueci-senha-form"] .scrollbar-inner').scrollbar();

        $('#esqueciSenhaFormValidate').validate({
            ignore: '.ignore',
            errorPlacement: function () {
                return true;
            },
            rules: {
              email: {
                    required: true,
                    email: true
                }
            },
            submitHandler: function (form) {

                var submittedForm = $(form);
                var componentID = parseInt(submittedForm.data("id"));

                submittedForm.find("button[type='submit']").attr("disabled", true);

                var esqueciSenhaData = {
                    "Email": submittedForm.find("input[name='email']").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/members/ForgotPassword",
                    data: JSON.stringify(esqueciSenhaData),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {
                        
                        if(response == true){
                            $("#esqueciSenhaFormValidate").each(function () {
                                this.reset();
                            });
                            $("#esqueci-senha-form").css("display", "none");
                            $("#esqueci-senha-confirm").css("display", "block");
                        }
                        else if(response == false){
                            $("#esqueci-senha-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde");
                        }
                        else if(response.length > 0){
                            $("#esqueci-senha-form").find(".error").text(response);
                        }
                    },
                    error: function error(e) {
                        $("#esqueci-senha-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde");
                    },
                    complete: function () {

                        submittedForm.find("button[type='submit']").attr("disabled", false);
                    }
                });
            }
        });
    }

    return this.init();
}